import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import router from './router';
import store from './store';
// import { Message } from 'element-ui'
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken, setToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
import { getUserAddLog } from '@/api/user';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

// const whiteList = ['/login'] // no redirect whitelist

router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(to, from, next) {
    var hasToken, current, params, hasRoles, roles, cardChannelType, accessRoutes;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          store.commit('settings/CLAER_CANCEL'); // 取消请求
          console.log(to, 'to');
          if (!(to.path == '/login' || to.path == '/openRonglian' || to.path == '/user/changePassword')) {
            _context.n = 1;
            break;
          }
          store.commit('user/RESET_STATE');
          next();
          return _context.a(2);
        case 1:
          hasToken = getToken();
          if (to.query.token) {
            setToken(to.query.token);
            store.commit('user/SET_TOKEN', to.query.token);
          }
          // 没有token 直接跳转登陆页
          // 没有token 直接跳转登陆页
          // if (!getToken()) {     只有测试使用
          // if (!hasToken) {       线上使用这个
          if (getToken()) {
            _context.n = 2;
            break;
          }
          return _context.a(2, next({
            path: '/login'
          }));
        case 2:
          // start progress bar
          NProgress.start();
          // set page title
          document.title = getPageTitle(to.meta.title);

          // determine whether the user has logged in
          // const hasToken = store.getters.token

          if (!store.getters.companyList.length) {
            // await store.dispatch('user/getCompanyList')
            //  await store.dispatch('user/getSellUsers')
            // await store.dispatch('user/getOperateUserList')
            // await store.dispatch('user/getOrganizeList')
          }
          if (store.getters.menus.length) {
            _context.n = 3;
            break;
          }
          _context.n = 3;
          return store.dispatch('user/getMenus');
        case 3:
          if (store.getters.head) {
            _context.n = 4;
            break;
          }
          _context.n = 4;
          return store.dispatch('user/getMyAvatar');
        case 4:
          if (!(!store.getters.serviceName || !store.getters.serviceName.length)) {
            _context.n = 5;
            break;
          }
          _context.n = 5;
          return store.dispatch('user/getServiceName');
        case 5:
          current = store.getters.menus.find(function (item) {
            var children = item.children;
            if (children.findIndex(function (item2) {
              return item2.path === to.path;
            }) !== -1) {
              return item;
            }
          }); // 当前路由是否二级菜单中，记录日志
          if (current) {
            params = {
              path: to.path
            };
            getUserAddLog(params).then(function (res) {
              console.log('记录日志');
              // 获取缓存中的定时器并清除
              var localTimer = localStorage.getItem('largeScreenTimer');
              localTimer && clearInterval(localTimer);
              localTimer && localStorage.removeItem('largeScreenTimer');
            });
          }
          next();
          NProgress.done();
          // determine whether the user has obtained his permission roles through getInfo
          hasRoles = store.getters.roles && store.getters.roles.length > 0;
          if (!hasRoles) {
            _context.n = 6;
            break;
          }
          next();
          _context.n = 10;
          break;
        case 6:
          _context.n = 7;
          return store.dispatch('user/getInfo');
        case 7:
          roles = _context.v;
          _context.n = 8;
          return store.dispatch('user/getCardChannelType');
        case 8:
          cardChannelType = _context.v;
          _context.n = 9;
          return store.dispatch('permission/generateRoutes', roles);
        case 9:
          accessRoutes = _context.v;
          // dynamically add accessible routes
          router.addRoutes(accessRoutes);
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next();
        case 10:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});